import { useTranslation } from 'react-i18next';
import { DoughnutChart } from 'src/common/components/Graphs/common/Graphs/DoughnutChart';
import { useSubscriptionStatusData } from './hooks/useSubscriptionStatusData';

type SubscriptionStatusChartProps = {
  accountRef: string;
};

export const SubscriptionStatusChart = (props: SubscriptionStatusChartProps) => {
  const { t } = useTranslation();

  const { chartData, total } = useSubscriptionStatusData(props);

  return (
    <DoughnutChart
      data={chartData}
      total={total}
      aria-label={t('dashboard.subscriptionsStatusChart.title')}
    />
  );
};
